export class downloadData
{
public scenarioId:string;
public institutionId:string;
public ownedUserId:string;
public downloaduserId:string;
public date:Date;
}